import React from 'react';

import {CompetitorPlayersStatsModuleController} from "../competitor-players-stats-module.controller";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {COMPETITOR_PLAYER_STATS} from "../competitor-players-stats-module.consts";
import {CompetitorPlayersStatsModuleProps} from "../models/competitor-players-stats-module.props";
import {CompetitorPlayersStatsModuleHeader} from "./competitor-players-stats-module.header";
import {CompetitorPlayersStatsModuleEmptyState} from "./competitor-players-stats-module.empty-state";
import {CompetitorPlayersStatsModulePlayerStats} from "./player-stats/competitor-players-stats-module.player-stats";
import {CompetitorPlayersStatsModulePlayerViewModel} from "../models/competitor-players-stats-module.player.view-model";
import {CompetitorPlayersStatsModuleFooterButtons} from "./competitor-players-stats-module.footer-buttons";
import styles from "../styles/competitor-players-stats-module.module.scss";
import classNames from "classnames";

export class CompetitorPlayersStatsModuleComponentProps extends CompetitorPlayersStatsModuleProps {
}

export const CompetitorPlayersStatsModuleComponent = (({
                                                         controller,
                                                         gameId,
                                                         source,
                                                         selectedAthleteId,
                                                         onClose,
                                                         competitionId
                                                       }: CompetitorPlayersStatsModuleComponentProps) => {
  const {state, device, terms: i18n} = controller;
  const {
    gameStatus,
    firstSelectedAthleteId,
    selectedPlayer,
    isFirstSelectedAthlete,
    shouldRenderStats,
    shouldRenderGameCard,
    sportContext
  } = state;
  const {contextClassName} = sportContext;
  const {isSmallView} = device;

  const onPlayerChange = (player: CompetitorPlayersStatsModulePlayerViewModel) => controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.onPlayerChange, {
    gameId,
    status: gameStatus,
    athleteId: player.athleteId,
    sportTypeId: player.sport.id,
    source,
    isHeatmap: !!player.heatMap,
    isFirst: firstSelectedAthleteId === player.athleteId
  });

  const onScrollToEnd = () => controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.statsScrolledHandler, {
    gameId,
    status: gameStatus,
    athleteId: selectedAthleteId,
    source: source,
    isHeatmap: !!selectedPlayer.heatMap,
    isFirst: isFirstSelectedAthlete
  });

  const headerProps = {
    controller,
    onPlayerChange: (athleteId) => onPlayerChange(athleteId),
    source
  }

  const statsProps = {
    gameId,
    controller,
    topStatsTitle: i18n.WEB_PLAYER_CARD_POPUP_TOP_STATS,
    onScrollToEnd: () => onScrollToEnd()
  }

  const emptyStateProps = {
    label: i18n.WEB_PLAYER_CARD_POPUP_STATS_NOT_AVAILABLE,
    imageWidth: state.emptyStateImageWidth,
    imageHeight: state.emptyStateImageHeight,
    isSmallView
  }

  const footerButtonsProps = {
    controller,
    onClose,
    competitionId
  }

  return (
    <div className={classNames(styles.competitor_players_stats_module, {[styles.small_view]: isSmallView, [styles.has_game]: shouldRenderGameCard}, contextClassName)}>
      <CompetitorPlayersStatsModuleHeader {...headerProps}/>
      {
        shouldRenderStats ? <CompetitorPlayersStatsModulePlayerStats {...statsProps}/> :
          <CompetitorPlayersStatsModuleEmptyState {...emptyStateProps}/>
      }
      <CompetitorPlayersStatsModuleFooterButtons {...footerButtonsProps}/>
    </div>
  )
});

const settings: ComposeSettings = {
  component: CompetitorPlayersStatsModuleComponent,
  propsType: CompetitorPlayersStatsModuleComponentProps,
  controllerType: CompetitorPlayersStatsModuleController,

  observe: true,
  createModule: true,
}

export const CompetitorPlayersStatsModule = Compose(settings);
